import {useCallback} from 'react';

import {useCommonDataHook} from 'src/hooks/use-common-data-hook';
import {bulkDischargeRoleGrants} from 'src/openapi/admin/apis/BulkDischargeRoleGrantsApi';
import {useAppDispatch} from 'src/store/hooks';

import type {Error} from 'src/openapi/admin/models/Error';
import type {SuccessPayload} from 'src/typedef';

export const useDischargeGrantsFromRole = () => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback(() => {
        const payload: {success: true, error: false, data: string[]} = {
            success: true,
            error: false,
            data: [],
        };
        return Promise.resolve({type: '', payload});
    }, []);

    const saveDispatchAction = useCallback(async (
        dischargedGrants: string[],
        signal: AbortSignal,
        options?: {roleId: string, reason?: string},
    ) => {
        const {roleId, reason} = options ?? {};
        if (!roleId) {
            const payload: {success: false, error: true, data: Error} = {
                success: false,
                error: true,
                data: {message: 'Role ID is required'},
            };
            return Promise.resolve({type: '', payload});
        }

        const dischargeGrantsResponse = await apiDispatch(bulkDischargeRoleGrants({
            reason,
            updateRoleGrant: {
                roleId,
                grantIds: dischargedGrants,
            },
        }, {signal}));

        if (dischargeGrantsResponse.payload.success) {
            const payload: SuccessPayload<undefined> = {
                success: true,
                error: false,
                data: undefined,
            };
            return Promise.resolve({type: '', payload});
        } else {
            return Promise.resolve({type: '', payload: dischargeGrantsResponse.payload});
        }
    }, [apiDispatch]);

    return useCommonDataHook({
        initValue: [],
        getDispatchAction,
        saveDispatchAction,
    });
};
